import { useQuery } from "@rocicorp/zero/react";
import { useZero } from "@/hooks/use-zero";

/**
 * Entries inside a collection, with their primary media row joined for
 * thumbnails. Returns the flat entry shape needed by the grid.
 */
export function useCollectionEntries(collectionId: string | undefined) {
  const z = useZero();
  const [rows, info] = useQuery(
    collectionId
      ? z.query.collection_entries
          .where("collection_id", "=", collectionId)
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          .related("entry", (e: any) =>
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            e.related("media", (m: any) => m.related("media")),
          )
      : false,
  );

  const entries = (rows ?? [])
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((r: any) => r.entry as EntryWithMedia | null)
    .filter((e): e is EntryWithMedia => !!e);

  return { entries, ...info };
}

export type EntryWithMedia = {
  id: string;
  title: string | null;
  kind: string;
  created_at: number;
  media: Array<{
    media_id: string;
    media: {
      id: string;
      mime_type: string;
      width: number | null;
      height: number | null;
      ingest_status: string;
      exif: Record<string, unknown> | null;
    } | null;
  }>;
};
